import React from 'react';
import PageIntro from '../../components/PageIntro/PageIntro';
import PaymentRequestsTable from '../../components/Table/PaymentRequestsTable';
import Pagination from '../../components/Pagination/Pagination';

const TalentPayment = () => {
  return (
    <div className='mx-auto max-w-7xl space-y-6'>
      <PageIntro title={'All payment requests'} />
      <PaymentRequestsTable />
      <Pagination />
    </div>
  );
};

export default TalentPayment;
